import newWaysToNomImage1Src from '@images/marketing/FindinStore-Hero1.jpg';
import newWaysToNomeImage2Src from '@images/marketing/FindinStore-Hero2.jpg';
import PLPHeroImage1Src from '@images/marketing/PLPs/Probiotics-Hero1.jpg';
import PLPHeroImage2Src from '@images/marketing/PLPs/Probiotics-Hero2.jpg';
export var newWaysToNomDiptychContent = {
    headline: 'More Ways to Nom',
    subhead: 'Not into a monthly dog food subscription? Fetch our recipes whenever you want them from your favorite retailer.',
    imageData: [
        {
            src: newWaysToNomImage1Src,
            alt: 'A golden retriever puppy',
        },
        {
            src: newWaysToNomeImage2Src,
            alt: 'A product image of a Nom Nom Beef Mash meal',
        },
    ],
    ctas: [
        {
            size: 'small',
            label: 'Find at Chewy',
            url: 'https://redir.pricespider.com/redirect?cid=66c7787e21e16619000c0cf0&url=https%3A%2F%2Fwww.chewy.com%2Fbrands%2Fnom-nom-136126&landingPageId=501',
            isExternalLink: true,
        },
        {
            size: 'small',
            label: 'Find at Petsmart',
            url: 'https://redir.pricespider.com/redirect?cid=66c7787e21e16619000c0cf0&url=https%3A%2F%2Fwww.petsmart.com%2Ffeatured-brands%2Fnom-nom&landingPageId=502&vid=989036',
            isExternalLink: true,
        },
    ],
};
export var PLPHeroContent = {
    headline: 'Nose-To-Tail Health',
    subhead: 'Dog parents know when their pup’s gut is out of whack. Our probiotics were vet-developed to support everything from digestion to immune system function. Your dog (and rug) will thank you.',
    imageData: [
        {
            src: PLPHeroImage1Src,
            alt: 'A healthy, black Labrador Retriever with a bandana around its neck plays in the grass',
        },
        {
            src: PLPHeroImage2Src,
            alt: 'Nom Nom Full-Spectrum Probiotic Support and Nom Nom GI-Targeted Probiotic Support',
        },
    ],
    ctas: [
        {
            label: 'Get Started',
            url: '/profile',
            use: 'funnel',
            size: 'large',
        },
    ],
};
